import { classNames } from "primereact/utils";

const inputTextarea = {
    root: ({ context }) => ({
        className: classNames(
            'm-0',
            'font-sans text-base text-allstate-navy bg-white dark:bg-gray-900 p-2.5 border border-grey-5 transition-colors duration-200 appearance-none rounded-md resize-none',
            'hover:border-allstate-blue focus:outline-none focus:outline-offset-0 focus:shadow-[0_0_0_0.2rem_rgba(191,219,254,1)] dark:focus:shadow-[0_0_0_0.2rem_rgba(147,197,253,0.5)]',
            { 'opacity-60 select-none pointer-events-none cursor-default': context.disabled }
        )
    })
};

export default inputTextarea;